import Vue from 'vue';
import Router from 'vue-router';
import AppShop from '../components/AppShop.vue';

Vue.use(Router);

//todo
//const AppShop = () => import('../components/AppShop.vue')

export function createRouter() {
  return new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      { path: '/shop/:slug', component: AppShop },
      { path: '/:locale/:slug', component: AppShop },
      { path: '/', component: AppShop },
    ]
  })
}